import BaseVm from '../BaseVm'
import { node } from '../../../utils/dom'
import { queryString } from '../../../utils/window'
import GoogleTagService from '../../services/GoogleTagService'
import { AD_FORMATS, CLASS_NAMES } from '../../config/adsConfig'
import { SELECTORS } from '../../../config/preRenderedSelectorsConfig'
import { getIsMobile, getIsTabletInPortrait, getIsDesktop } from '../../../utils/ua'
import { adStore, EMPTY_SLOT_DIMENSIONS, EMPTY_SLOT_SIZES_OBJECT } from '../../stores/adStore'
import { allSlotsRendered, slotRendered } from '../../actions/adActions'

const { adsDebugSizes } = queryString
const HEADER_ADDED_HEIGHT = 24
const { EMPTY: EMPTY_AD } = CLASS_NAMES

function getAdSlotSizeFromDfpEvent(dfpEvent) {
  const size = dfpEvent.size || EMPTY_SLOT_DIMENSIONS
  const [width = 0, height = 0] = size
  return { width, height }
}

export default class AdVm extends BaseVm {
  constructor(options = {}) {
    super(options)
    const { googletag: gTag } = window
    const { actions, adId, adConfig: adData, type } = options
    this.merge({
      actions,
      adData,
      adId,
      gTag,
      type,
    })
    this.gTagService = GoogleTagService.create()
  }

  onChange(
    payload = {
      event: { isEmpty: null, slideshowRefreshAction: false, resetPageTargetingLimit: false },
    }
  ) {
    const { adId, event: { isEmpty, slideshowRefreshAction, resetPageTargetingLimit } } = payload
    if (isEmpty !== null && adId === this.adId) {
      this.emptySlot = {
        isEmpty,
        adId,
      }
    }
    if (slideshowRefreshAction && adStore.shouldRefreshSlot) {
      adStore.state.topSlotHeight = false
      this.gTagService.refreshSlot(this.gTagService.slots[this.adId])
    }
    if (resetPageTargetingLimit) {
      this.gTagService.resetPageTargetingLimit()
    }
    return super.onChange()
  }

  get emptySlot() {
    return (adStore.state[this.adId] || {}).emptySlot || false
  }

  set emptySlot(emptySlot) {
    adStore.state[this.adId] = adStore.state[this.adId] || {}
    adStore.state[this.adId].emptySlot = emptySlot
  }

  get topHeight() {
    return adStore.state.topSlotHeight
  }

  get adSize() {
    return (adStore.state[this.adId] || {}).adSize || EMPTY_SLOT_SIZES_OBJECT
  }

  initSlot() {
    const { adId, type, adData } = this
    this.gTagService.initSlot(adData, type, adId)
    return this
  }

  display() {
    this.initTargeting()
    return this
  }

  initAndDisplay() {
    const headerAd = node(SELECTORS.HEADER_AD_UNIT)
    this.initSlot().display()
    if (!headerAd) {
      return this
    }
    if (adStore.isAdblockPresent) {
      headerAd.classList.add(EMPTY_AD)
    }

    return this
  }

  initDisplayAndHideOnTimeOut(timeout) {
    this.initAndDisplay()
    setTimeout(
      function hideAdOnTimeout() {
        this.hide()
      }.bind(this),
      timeout
    )
    return this
  }

  hide() {
    this.actions.slotHide(this.adId)
    return this
  }

  dfpSlotRenderEndedEvent(dfpEvent) {
    const { adId } = this
    if (dfpEvent.slot !== this.gTagService.slots[adId]) {
      return this
    }
    adsDebugSizes && this.warn('dfpSlotRenderEndedEvent:', adId, dfpEvent)
    const { isEmpty: isAdEmpty } = dfpEvent
    slotRendered({
      adId,
      isAdEmpty,
      size: getAdSlotSizeFromDfpEvent(dfpEvent),
      adRenderedEvent: dfpEvent,
    })
    this.gTagService.renderedAdsEvents[adId] = dfpEvent
    const isAllSlotsRendered =
      Object.keys(this.gTagService.slots).length ===
      Object.keys(this.gTagService.renderedAdsEvents).length
    if (isAllSlotsRendered) {
      // TODO: Remove this bad interstitial hack once the interstitial rendering code is moved from the SLIM to the client JS code
      if (window.__NMinterstitialEventHack) {
        this.gTagService.renderedAdsEvents.Interstitial = window.__NMinterstitialEventHack
      }
      allSlotsRendered(this.gTagService.renderedAdsEvents)
    }
    return this
  }

  initTargeting() {
    const { adId, adData, type } = this
    this.gTagService.initTargeting(adData, adId, this.dfpSlotRenderEndedEvent.bind(this), type)
    return this
  }

  get stickyConf() {
    const isStickyOnPlatformMap = this.adData.isSticky || {}
    if (!Object.keys(isStickyOnPlatformMap).length) {
      return false
    }
    let stickyPlatform
    if (getIsTabletInPortrait()) {
      stickyPlatform = 'portraitTablet'
    } else if (getIsMobile()) {
      stickyPlatform = 'mobile'
    } else {
      stickyPlatform = 'desktop'
    }
    return isStickyOnPlatformMap[stickyPlatform]
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/AdVm.js